import React, { useCallback, useEffect, useState, useRef } from "react";
import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  Background,
  Controls,
  useNodesState,
  useEdgesState,
} from "react-flow-renderer";
import {
  Avatar,
  Box,
  Button,
  Card,
  FormControl,
  FormLabel,
  HStack,
  IconButton,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  Textarea,
  useDisclosure,
  Spinner,
  Flex,
  useToast,
  Tooltip,
} from "@chakra-ui/react";
import {
  add_executorApi,
  createAgentApi,
  GettingAllAgents,
  resetFlowApi,
  runFlowSequence,
  saveFlowSequence,
  testAutomationWorkflowApi,
} from "../allApi/api";
import { useSelector } from "react-redux";
import AICoWorkerCard from "./waveflow/DropNodeCard";
import saveicon from "../assets/waveflowmain/save_icon.png";
import playIcon from "../assets/waveflowmain/play_icon.png";
import ChatBotPage from "./chatbot/ChatBotPage";
import runFlowBlue from "../assets/waveflowmain/runFlowBlue.png";
import saveFlowBlue from "../assets/waveflowmain/saveFlowBlue.png";
import chatbot_agentPhoto from "../assets/waveflowmain/chatbot_agentPhoto.png";
import useUndoable from "use-undoable";
import saveWhiteIcone from "../assets/waveflowmain/saveWhiteIcone.png";
import exstractIcon from "../assets/waveflowmain/exstractIcon.png";
import AutomationPrompt from "./waveflow/Automation/AutomationPrompt";
import SelectionComponent from "../components/SidebarComponent/RadioOption";
import { useCustomTost } from "../utiils/useCustomTost";
import AiWebSearch from "./aiWebSearch/aiwebsearch/AiWebSearch";
import { BiChevronRight, BiChevronLeft } from "react-icons/bi";
import { motion } from "framer-motion";
import CreatingAgentSequenceLoader from "../components/loader/RunSequnceLoader";
import SkeletonAgentDataList from "../components/loader/skeletonLoader/SkeletonAgentData";
import { useDispatch } from "react-redux";
import {
  allAgentsFetch,
  waveflowclearefetchagentsData,
  waveflowResetLoading,
} from "../redux/reducer/waveFlow";
import ResetButton from "../components/AlertModel/RecetBtn";
import { addfinalanswerFun } from "../redux/reducer/agentcanvas";
import SchedularDate from "../components/DateFormat/SchedularDate";
import { AddIcon } from "@chakra-ui/icons";
import NoAgentFound from "../components/AgentNotFound/AgentNotFound";
const MotionIcon = motion(IconButton);
const initialNodes = [];
const initialEdges = [];

const Sidebar = ({ sidebarSlide, nodeList, setNodeList }) => {
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  function truncateText(text, charLimit) {
    if (text?.length > charLimit) {
      return text.slice(0, charLimit) + "...";
    }
    return text;
  }

  const onDragStart = (event, nodeData) => {
    event.dataTransfer.setData(
      "application/reactflow",
      JSON.stringify(nodeData)
    );
    event.dataTransfer.effectAllowed = "move";
  };

  const handleAddExecutor = async () => {
    try {
      setLoading(true);
      const payload = {
        executors: 1,
        session_id: nodeList[0]?.session_id,
      };

      const data = await add_executorApi(payload);
      if (!data || !Array.isArray(data.message) || !data.message[0]) {
        throw new Error("Invalid response or server not reachable");
        return;
      }

      if (data?.message?.[0]) {
        setNodeList((prev) => [...prev, data?.message?.[0]]);
        toast({
          title: "Executor added.",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      }
    } catch (err) {
      console.error("Error adding executor:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <aside
      style={{
        backgroundColor: "#f7f8fa",
        height: "100%",
        overflowY: "auto",
        boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
      }}
    >
      {nodeList?.length == 0 ? (
        <NoAgentFound />
      ) : nodeList && nodeList?.length > 0 ? (
        nodeList
          .filter((node) => !node?.file_name)
          .map(
            (node, index) =>
              // node?.type == "tool" ? (
              //   <div
              //     key={index}
              //     onDragStart={(event) => onDragStart(event, node)}
              //     draggable
              //   >
              //     <Card mb={"5px"}>
              //       <HStack
              //         justifyContent="space-between"
              //         alignItems="center"
              //         p={sidebarSlide ? 2 : 1}
              //       >
              //         <HStack>
              //           <Image w={"30px"} src={node?.tool_details?.logo} />{" "}
              //           {/* <Avatar w="30px" h="30px" name={node?.name} /> */}
              //           {sidebarSlide && (
              //             <Stack spacing={0}>
              //               <Text fontSize={"12px"} fontWeight="semibold">
              //                 {node?.name}
              //               </Text>
              //               <Text fontSize={"12px"} color="gray.500">
              //                 {truncateText(node?.description, 20)}
              //               </Text>
              //             </Stack>
              //           )}
              //         </HStack>
              //       </HStack>
              //     </Card>
              //   </div>
              // ) : (
              (node?.type == "agent" || node?.type == "executor node") && (
                <div
                  key={index}
                  onDragStart={(event) => onDragStart(event, node)}
                  draggable
                >
                  <Card mb={"5px"}>
                    <HStack
                      justifyContent="space-between"
                      alignItems="center"
                      p={sidebarSlide ? 2 : 1}
                    >
                      <HStack>
                        <Avatar w="30px" h="30px" name={node?.name} />
                        {sidebarSlide && (
                          <Stack spacing={0}>
                            <Text fontSize={"12px"} fontWeight="semibold">
                              {node?.name}
                            </Text>
                            <Text fontSize={"12px"} color="gray.500">
                              {truncateText(node?.description, 20)}
                            </Text>
                          </Stack>
                        )}
                      </HStack>
                    </HStack>
                  </Card>
                </div>
              )
            // )
          )
      ) : (
        <SkeletonAgentDataList />
      )}

      {nodeList && nodeList.length > 0 && (
        <Flex justifyContent="flex-end" w="100%" p={2}>
          <Button
            bg={"lightblue"}
            fontSize={"20px"}
            p={0}
            isLoading={loading}
            onClick={handleAddExecutor}
          >
            +
          </Button>
        </Flex>
      )}
    </aside>
  );
};
const WaveFlow2 = ({ data, setData, editNodeData }) => {
  const [files, setFiles] = useState([]);
  const [sequenceLoder, setsequenceLoder] = useState(false);
  const [sidebarSlide, setSidebarSlide] = useState(true);
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const [resetBtnState, setresetBtnState] = useState(false);
  const [saveLoder, setsaveLoder] = useState(false);
  const [waveFlowError, setWaveFlowError] = useState("");
  const [flowFormData, setFlowFormData] = useState({
    flowname: "",
    flowDesc: "",
  });
  const toast = useCustomTost();
  const [btnLoading, setBtnLoading] = useState("");
  const dispatch = useDispatch();
  const previousAgents = useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isopenSave,
    onOpen: onOpenSave,
    onClose: onCloseSave,
  } = useDisclosure();

  const {
    isOpen: isopenLoader,
    onOpen: onOpenLoader,
    onClose: onCloseLoader,
  } = useDisclosure();

  const [runflowbtn, setRunFlowBtn] = useState(false);
  const [saveflowbtn, setSaveFlowBtn] = useState(false);
  const [createAgentLoader, setcreateAgentLoader] = useState(false);
  const agentavailable = useSelector(
    (state) => state.waveflowSearchData.availableAgent
  );
  const waveFlowUpdate = useSelector(
    (state) => state.waveflowSearchData.agentaddTrigger
  );
  const waveFlowChatUserOption = useSelector(
    (state) => state.waveflowSearchData.waveFlowChatUserOption
  );
  const { clearefetchagentsData, allAgentData } = useSelector(
    (state) => state.waveflowSearchData
  );

  const [nodeList, setNodeList] = useState([]);
  const [flowChatOption, setFlowChatOption] = useState(waveFlowChatUserOption);

  const [formDataAutomation, setformDataAutomation] = useState({
    query: "",
    session_id: "",
    time: 30,
    flowname: "",
    workflow_type: flowChatOption,
    flowDesc: "",
    files: [],
    cycleType: "immediate",
    start_date: null,
    start_time: null,
    repeat_interval: null,
    repeat_unit: "minutes",
    cycle_count: null,
  });

  const nodeSequence = ["Node A", "Node B", "Node C"];

  const onConnect = useCallback(
    (params) => {
      const { source, target } = params;

      const sourceNode = nodes.find((node) => node.id === source);
      const targetNode = nodes.find((node) => node.id === target);

      if (!sourceNode || !targetNode) {
        toast("Error", "Invalid connection.", "error");
        return;
      }

      const sourceIndex = nodeSequence.indexOf(sourceNode.data.name);
      const targetIndex = nodeSequence.indexOf(targetNode.data.name);

      if (sourceIndex !== -1 && targetIndex === sourceIndex + 1) {
        setEdges((eds) => addEdge(params, eds));
      } else {
        toast("Warning!", "Nodes must be connected in sequence!", "warning");
      }
    },
    [nodes, setEdges]
  );

  const onDrop = useCallback(
    (event) => {
      event.preventDefault();
      const nodeData = JSON.parse(
        event.dataTransfer.getData("application/reactflow")
      );
      if (!nodeData) return;

      // if (data.includes(nodeData?.id)) {
      //   toast("Warning", "This agent is already added.", "warning");
      //   return;
      // }
      const horizontalSpacing = 150;
      const xOffset = nodes?.length * horizontalSpacing;

      const position = {
        x: xOffset,
        y: 50,
      };

      const newNode = {
        id: `${+new Date()}`,
        type: "default",
        position,

        style: {
          width: "fit-content",
          height: "fit-content",
          padding: 2,
          //  animated: true,
          overflow: "hidden",
          borderRadius: "20px",
          border: "1px solid rgba(131, 195, 255, 1)",
          // boxShadow:
          //   "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
        },
        data: {
          label: (
            <Box>
              <AICoWorkerCard node={nodeData} />
            </Box>
          ),
        },
      };
      setNodes((nds) => nds.concat(newNode));
      setData((prevData) => [...prevData, nodeData.id]);

      setEdges((eds) => {
        if (nodes?.length > 0) {
          const sourceNode = nodes[nodes?.length - 1];
          const newEdge = {
            id: `e${sourceNode.id}-${newNode.id}`,
            source: sourceNode.id,
            target: newNode.id,
            animated: true,
            style: { stroke: "#2B6CB0", strokeWidth: 2 },
          };
          return eds.concat(newEdge);
        }
        return eds;
      });
    },
    [nodes, setNodes, setEdges, setData, agentavailable]
  );
  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }, []);

  const handleSubmit = async () => {
    const payload = {
      agents: data,
      file_name: "agents",
      aichatOption: flowChatOption,
    };
    setsequenceLoder(true);
    onOpenLoader();
    dispatch(addfinalanswerFun(""));
    try {
      const response = await runFlowSequence(payload);
      console.log("responseINWaveflow", response);

      setBtnLoading(response?.sequence);
      if (response?.sequence) {
        onOpen();
      } else {
        console.error("Failed to submit data:");
      }
    } catch (error) {
      console.error("Error during submission:", error);
    } finally {
      setsequenceLoder(false);
      onCloseLoader();
    }
  };

  const handleOpenSave = () => {
    setWaveFlowError("");
    onOpenSave();
  };

  const saveWorkFlowHandle = async () => {
    setWaveFlowError("");
    if (!flowFormData?.flowname || !flowFormData?.flowDesc) {
      setWaveFlowError("please add Name and Description ");
      return;
    }
    setsaveLoder(true);
    try {
      const response = await saveFlowSequence({
        ...flowFormData,
        workflow_type: "Conversational_ai",
      });
      if (response?.message == "success") {
        toast(
          "Flow save successfully.",
          "workflow save successfully.",
          "success"
        );
      }
    } catch (error) {
      console.error("Error during save:", error);
    } finally {
      setsaveLoder(false);
    }
    setFlowFormData({});
    onCloseSave();
  };

  const validateForm = () => {
    const {
      cycleType,
      start_date,
      start_time,
      repeat_interval,
      repeat_unit,
      cycle_count,
    } = formDataAutomation;

    if (cycleType === "immediate") {
      // ✅ No validation needed
      return true;
    }

    if (cycleType === "regular_interval") {
      if (
        !start_date ||
        !start_time ||
        !repeat_interval ||
        !repeat_unit ||
        !cycle_count
      ) {
        toast(
          "Missing Fields",
          "Please fill all required fields for Regular Interval.",
          "error"
        );
        return false;
      }
    }

    if (cycleType === "custom") {
      if (!start_date || !start_time) {
        toast(
          "Missing Fields",
          "Start date and time are required for Custom Schedule.",
          "error"
        );
        return false;
      }
    }

    return true;
  };

  const [testAutomationLoading, setTestAutomationLoading] = useState(false);
  const testAutomationWorkflowApiHandle = async () => {
    if (!validateForm()) return;
    setTestAutomationLoading(true);
    const fileNames = files.map((file) => file.name);
    const start_date = SchedularDate(formDataAutomation.start_date);
    const session_id = localStorage.getItem("session_id");

    try {
      const response = await testAutomationWorkflowApi({
        ...formDataAutomation,
        files: fileNames,
        workflow_type: flowChatOption,
        start_date,
        session_id,
      });
      if (response?.message == "success") {
        toast(
          "Flow save successfully.",
          "Your changes have been saved.",
          "success"
        );
      }
    } catch (error) {
      console.error("Error during save:", error);
    } finally {
      setTestAutomationLoading(false);
      setformDataAutomation({});
    }
    onClose();
  };
  const saveWorkAutomation = async () => {
    setsaveLoder(true);
    try {
      const response = await saveFlowSequence({
        ...formDataAutomation,
        workflow_type: "BusinessAutomation",
      });
      if (response?.message == "success") {
        toast(
          "Flow save successfully.",
          "Your changes have been saved.",
          "success"
        );
      }
    } catch (error) {
      console.error("Error during save:", error);
    } finally {
      setsaveLoder(false);
    }

    setFlowFormData({});
    onCloseSave();
  };
  const [isOpenReset, setIsOpenReset] = useState(false);

  const resetFlowHandle = async () => {
    if (!nodes || nodes?.length <= 0) {
      toast("Warning!", "No any flow for reset.", "warning");
      return;
    }
    try {
      dispatch(waveflowResetLoading(true));
      const res = await resetFlowApi();
      setresetBtnState(true);

      dispatch(waveflowclearefetchagentsData());
      setEdges([]);
      setNodes([]);
      setData([]);
      if (res.status == "success") {
        toast("Success!", "reset Flow successfully.", "success");
      }
    } catch (error) {
      console.log("reset api :", error);
    } finally {
      dispatch(waveflowResetLoading(false));
      setIsOpenReset(false);
    }
    setEdges([]);
    setNodes([]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFlowFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setformDataAutomation((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitForFlow =
    flowChatOption === "Conversationalai"
      ? saveWorkFlowHandle
      : saveWorkAutomation;

  useEffect(() => {
    if (allAgentData && allAgentData?.length > 0) {
      setNodeList(allAgentData);
    }
  }, [allAgentData]);

  useEffect(() => {
    if (editNodeData && editNodeData?.agents.length > 0) {
      setNodeList(editNodeData?.agents);
      if (editNodeData?.workflow_name) {
        localStorage.setItem(
          "session_id",
          editNodeData?.agents?.[0]?.session_id
        );
      }
    }
  }, [editNodeData]);

  useEffect(() => {
    const fetchData = async () => {
      if (resetBtnState) {
        const idsOfData = nodeList?.map((item) => item.id);
        const idsOfPreviousData = previousAgents?.current?.map(
          (item) => item.id
        );

        if (idsOfData?.[0] !== idsOfPreviousData?.[0]) {
          setNodes([]);
          setEdges([]);
          previousAgents.current = nodeList;
        }

        setNodeList(nodeList);
        setresetBtnState(false);
      }
    };

    fetchData();
  }, [resetBtnState]);

  const handleCreateAgent = async (session_id) => {
    setcreateAgentLoader(true);
    try {
      const res = await createAgentApi({ session_id });
      setNodeList(res?.agents);
    } catch (error) {
      console.error("Error while create agent :", error);
    } finally {
      setcreateAgentLoader(false);
    }
  };

  useEffect(() => {
    if (!clearefetchagentsData) {
      dispatch(allAgentsFetch());
    }
  }, [clearefetchagentsData, agentavailable]);

  useEffect(() => {
    setNodes([]);
    setEdges([]);
  }, [waveFlowUpdate]);

  useEffect(() => {
    setFlowChatOption(waveFlowChatUserOption);
  }, [waveFlowChatUserOption]);

  return (
    <ReactFlowProvider>
      <div
        style={{
          display: "flex",
          height: "80vh",
          position: "relative",
        }}
      >
        <div
          style={{
            flex: 1,
            backgroundColor: "#fafafa",
            borderRadius: "7px",
          }}
          onDrop={onDrop}
          onDragOver={onDragOver}
        >
          <HStack justifyContent={"space-between"}>
            <ResetButton
              resetFlowHandle={resetFlowHandle}
              isOpen={isOpenReset}
              setIsOpen={setIsOpenReset}
            />
            <SelectionComponent />

            <Box>
              <Button
                draggable="false"
                isDisabled={nodes?.length === 0}
                pointerEvents={nodes?.length === 0 ? "none" : "visible"}
                variant="outline"
                size="xs"
                onClick={handleSubmit}
                onMouseDown={() => setRunFlowBtn(true)}
                onMouseUp={() => setRunFlowBtn(false)}
                onMouseLeave={() => setRunFlowBtn(false)}
              >
                <HStack spacing={1}>
                  <Image
                    draggable={false}
                    src={runflowbtn ? runFlowBlue : playIcon}
                    alt="Icon"
                    boxSize="14px"
                  />
                  <Text
                    _active={{
                      color: "rgba(89, 35, 231, 1)",
                    }}
                    color={runflowbtn ? "rgba(89, 35, 231, 1)" : ""}
                  >
                    Run
                  </Text>
                </HStack>
              </Button>

              <Modal
                isCentered
                blockScrollOnMount={false}
                isOpen={isOpen}
                onClose={onClose}
                closeOnOverlayClick={false}
              >
                <ModalOverlay />
                <ModalContent w={["75%", "75%"]} maxW="75%" h={"fit-content"}>
                  <ModalBody w={"100%"}>
                    <HStack justifyContent={"space-between"}>
                      {flowChatOption == "Conversationalai" && (
                        <HStack draggable={false}>
                          <Image
                            draggable={false}
                            w={"25px"}
                            src={chatbot_agentPhoto}
                          />
                          <Text draggable={false} fontWeight={500}>
                            Hi! How can I help you?
                          </Text>
                        </HStack>
                      )}

                      <ModalCloseButton draggable={false} />
                    </HStack>
                    {flowChatOption == "Conversationalai" ? (
                      <ChatBotPage />
                    ) : flowChatOption == "BusinessAutomation" ? (
                      <AutomationPrompt
                        onClose={onClose}
                        formDataAutomation={formDataAutomation}
                        files={files}
                        setFiles={setFiles}
                        setformDataAutomation={setformDataAutomation}
                      />
                    ) : (
                      <Box w={"100%"}>
                        <AiWebSearch ModalCloseButton={ModalCloseButton} />
                      </Box>
                    )}
                  </ModalBody>
                  {flowChatOption == "BusinessAutomation" && (
                    <ModalFooter>
                      <Button mr={3} onClick={onClose}>
                        Cancel
                      </Button>
                      <Button
                        onClick={testAutomationWorkflowApiHandle}
                        bg="yourDefaultColor"
                        _hover={{
                          bg: "yourDefaultColor",
                        }}
                        bgGradient="linear(to-r, rgba(190, 105, 255, 1), rgba(96, 133, 255, 1))"
                      >
                        <HStack spacing={2}>
                          <Text color={"white"}>
                            {testAutomationLoading ? <Spinner /> : "Submit"}
                          </Text>
                        </HStack>
                      </Button>
                    </ModalFooter>
                  )}
                </ModalContent>
              </Modal>

              <Button
                draggable={false}
                isDisabled={nodes?.length === 0}
                pointerEvents={nodes?.length === 0 ? "none" : "visible"}
                variant="outline"
                size="xs"
                _active={{
                  bg: "rgba(45, 15, 150, 1)",
                }}
                onMouseDown={() => setSaveFlowBtn(true)}
                onMouseUp={() => setSaveFlowBtn(false)}
                onMouseLeave={() => setSaveFlowBtn(false)}
                onClick={handleOpenSave}
              >
                <HStack spacing={1}>
                  <Image
                    draggable={false}
                    src={saveflowbtn ? saveFlowBlue : saveicon}
                    alt="Icon"
                    boxSize="14px"
                  />
                  <Text color={"black"}>Save</Text>
                </HStack>
                <Modal isOpen={isopenSave} onClose={onCloseSave}>
                  <ModalOverlay bg="transparent" />
                  <ModalContent
                    w={["75%", "60%"]}
                    maxW="35%"
                    top="30px"
                    right="-150"
                    boxShadow={"rgba(0, 0, 0, 0.35) 0px 5px 15px"}
                  >
                    <ModalHeader fontWeight={700}>
                      {flowChatOption == "Conversationalai"
                        ? "Save your Workflow"
                        : "Save your Business Automation Workflow"}
                    </ModalHeader>
                    <ModalBody>
                      <Box>
                        <FormControl>
                          <FormLabel fontWeight={500}>Name</FormLabel>
                          <Input
                            name="flowname"
                            h={"45px"}
                            value={
                              flowFormData.flowname ||
                              editNodeData?.workflow_name
                            }
                            onChange={handleChange}
                            placeholder="Name your new workflow, this can be viewed in workflow admin"
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel fontWeight={500}>Description</FormLabel>
                          <Textarea
                            name="flowDesc"
                            h={"60px"}
                            value={flowFormData.flowDesc}
                            onChange={handleChange}
                            placeholder="Write a brief description for your workflow"
                          />
                        </FormControl>
                        {waveFlowError && (
                          <Text color={"red"}>{waveFlowError}</Text>
                        )}
                      </Box>
                    </ModalBody>
                    <ModalFooter>
                      <Button mr={3} onClick={onCloseSave}>
                        Cancel
                      </Button>
                      <Button
                        onClick={handleSubmitForFlow}
                        bg="yourDefaultColor"
                        _hover={{
                          bg: "yourDefaultColor",
                        }}
                        bgGradient="linear(to-r, rgba(190, 105, 255, 1), rgba(96, 133, 255, 1))"
                      >
                        <HStack spacing={2}>
                          <Text color={"white"}>Save</Text>
                          {saveLoder ? (
                            <Spinner />
                          ) : (
                            <Image
                              src={saveWhiteIcone}
                              alt="Icon"
                              boxSize="18px"
                            />
                          )}
                        </HStack>
                      </Button>
                    </ModalFooter>
                  </ModalContent>
                </Modal>
              </Button>
            </Box>
          </HStack>
          <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onConnect={onConnect}
            selectionStyles={{
              border: "none",
              outline: "none",
              boxShadow: "none",
            }}
          >
            <Background />
            {/* <MiniMap /> */}
            <Controls />
          </ReactFlow>
          {sequenceLoder && (
            <Modal
              isOpen={isopenLoader}
              onClose={onCloseLoader}
              isCentered
              blockScrollOnMount={false}
              closeOnOverlayClick={false}
            >
              <ModalOverlay
                bg="rgba(255, 255, 255, 0.4)"
                backdropFilter="blur(4px)"
              />
              <ModalContent
                bg="transparent"
                boxShadow="none"
                p={6}
                w={["100%"]}
                textAlign="center"
              >
                <ModalBody
                  mt={"15%"}
                  ml={"20%"}
                  boxShadow={"none"}
                  bg={"transparent"}
                  w={"100%"}
                  textAlign={"center"}
                >
                  <CreatingAgentSequenceLoader />
                </ModalBody>
              </ModalContent>
            </Modal>
          )}
        </div>
        <Box
          w={sidebarSlide ? "20%" : "5%"}
          transition="width 0.5s"
          borderRadius={"7px"}
          border={"1px solid lightgray"}
        >
          <HStack mt={"5px"} pl={1} pr={1} boxSizing={"border-box"}>
            <MotionIcon
              icon={<BiChevronLeft size={"20px"} />}
              aria-label="Toggle Sidebar"
              p={0}
              size={"xs"}
              bg="gray.500"
              color="white"
              _hover={{ bg: "gray.600" }}
              onClick={() => setSidebarSlide(!sidebarSlide)}
              animate={{ rotate: sidebarSlide ? 180 : 0 }}
              transition={{ duration: 0.3 }}
            />

            {sidebarSlide && (
              <HStack>
                <Text
                  fontSize={"12px"}
                  fontWeight={500}
                  color={"rgba(108, 114, 117, 0.75)"}
                >
                  AI Co-Workers
                </Text>

                <Box
                  borderRadius={"6px"}
                  marginLeft="auto"
                  p={1}
                  bg={"rgba(232, 236, 239, 1)"}
                >
                  <Text
                    color={"rgba(108, 114, 117, 1)"}
                    boxSizing={"border-box"}
                    px={1}
                    fontSize={"10px"}
                  >
                    {nodeList?.length}
                  </Text>
                </Box>
                {/* <Tooltip label="Add Agent" hasArrow placement="top">
                  <IconButton
                    aria-label="Add Agent"
                    icon={
                      createAgentLoader ? (
                        <Spinner size="sm" color="white" />
                      ) : (
                        <AddIcon />
                      )
                    }
                    size="xs"
                    borderRadius="md"
                    color="white"
                    bg={"#0094FB"}
                    _hover={{ bg: "#0077CC" }}
                    isDisabled={createAgentLoader || !nodeList?.[0]?.session_id}
                    onClick={() => handleCreateAgent(nodeList?.[0]?.session_id)}
                  />
                </Tooltip> */}
              </HStack>
            )}
          </HStack>
          <Sidebar
            sidebarSlide={true}
            nodeList={nodeList}
            setNodeList={setNodeList}
          />
        </Box>
      </div>
    </ReactFlowProvider>
  );
};

export default WaveFlow2;
